import React, { useEffect, useRef } from "react";
import BreadcrumbPill from "web/react/components/breadcrumb-pill/breadcrumb-pill";
import styles from "./feeds-suggested-filters-pills.module.css";

interface SuggestionPill {
    name: string;
    value: string;
    url: string;
    label: string;
}

interface SuggestionPillProps {
    suggestedFilters: SuggestionPill[];
    onClick: (option) => void;
}

function SuggestionPills({ suggestedFilters, onClick }: SuggestionPillProps): null | JSX.Element {
    const showSuggestedOptions = suggestedFilters && suggestedFilters.length > 0;
    let scrollableWrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (scrollableWrapperRef && scrollableWrapperRef.current) {
            scrollableWrapperRef.current.scrollLeft = 0;
        }
    });

    return (
        <>
            {showSuggestedOptions ? (
                <div className={styles.scrollableWrapper} ref={scrollableWrapperRef}>
                    <ul className={styles.pills}>
                        {suggestedFilters.map((option) => (
                            <li className={styles.pill} key={`${option.name}=${option.value}`}>
                                <BreadcrumbPill
                                    onClick={(): void => onClick(option)}
                                    title={option.label}
                                    href={option.url}
                                    iconName="plus-thin"
                                    iconPosition="before"
                                />
                            </li>
                        ))}
                    </ul>
                </div>
            ) : null}
        </>
    );
}

export default SuggestionPills;
